/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getSubModulesByRoleId,
  getVendorDataForDownload,
  getVendorUpload,
  getVendorsListForPlanner,
  uploadCsvForVendorUpload,
} from "../../store";

// React-Select component and styling
import Select from "react-select";

import { CSVLink } from "react-csv";

// config file

// Cookies
import { Alert, Collapse } from "@mui/material";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const VendorUpload = ({
  getVendorUpload,
  vendorUploadReducer,
  getVendorDataForDownload,
  vendorDataForDownloadReducer,
  uploadCsvForVendorUpload,
  getVendorsListForPlanner,
  vendorsListForPlannerReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let user = cookies.get("loginDetailsForWMS");
  // let role = user.data.data.role;
  let roleName = user.data.roleName;
  let roleId = user.data.roleId;
  let userId = user.data.userId;
  let jwtToken = user?.jwt;

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const subModuleId = "80342974-7131-45db-8f4e-d7b1a65470d4";

  let vendorStockModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "80342974-7131-45db-8f4e-d7b1a65470d4",
  );

  let uploadAccess = vendorStockModule
    ? vendorStockModule.actionId.includes(
        "2f5bb42f-16f7-414f-bb66-8dd2c6e98221",
      )
    : null;
  let downloadAccess = vendorStockModule
    ? vendorStockModule.actionId.includes(
        "b8d76759-27a4-4bc2-95ec-bb45a7bb6389",
      )
    : null;

  let viewAccess = vendorStockModule
    ? vendorStockModule.actionId.includes(
        "d09a1208-0b51-4e00-9c17-0433650dbc65",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [uploadLoader, setUploadLoader] = useState(false);

  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");

  useEffect(() => {
    getVendorsListForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    getVendorUpload(
      userId,
      vendorsListForPlannerSelected ? vendorsListForPlannerSelected.value : "",
      roleName,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [
    userId,
    vendorsListForPlannerSelected,
    pageNo,
    rowsPerPage,
    searchObject,
  ]);

  useEffect(() => {
    getVendorDataForDownload(userId, jwtToken);
  }, [userId]);

  const [state, setState] = useState({
    columns: [
      { Header: "Part No", accessor: "itemCode", align: "left" },
      {
        Header: "Part Description",
        accessor: "itemDescription",
        align: "left",
      },
      { Header: "Vendor Code", accessor: "vendorCode", align: "left" },
      { Header: "Vendor Name", accessor: "vendorName", align: "left" },
      { Header: "Vendor Stock", accessor: "stock", align: "left" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [tableHeading, setTableHeading] = useState("");
  const [vendorCodeName, setVendorCodeName] = useState("");
  const [openGrnItemModal, setOpenGrnItemModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const handleOpenGrnItemModal = () => {
    setOpenGrnItemModal(!openGrnItemModal);
  };

  const [lineItems, setLineItems] = useState({});

  const handleOpenLineItemsModal = (lineItems = {}) => {
    setLineItems(lineItems);
  };

  useEffect(() => {
    let tempGRN = [];
    let data = vendorUploadReducer.vendorUploadData.data
      ? vendorUploadReducer.vendorUploadData.data
      : [];
    setLoading(vendorUploadReducer.loading);
    setPaginationObj(vendorUploadReducer.vendorUploadData.pagination);
    data.map((singleData) => {
      const singleUser = {
        itemCode: singleData.itemCode,
        itemDescription: singleData.itemDescription,
        vendorCode: singleData.vendorCode,
        vendorName: singleData.vendorName,
        stock: singleData.stock,
      };
      tempGRN.push(singleUser);
    });
    viewAccess && setState({ ...state, rows: tempGRN });
  }, [vendorUploadReducer]);

  let dataForDownload = vendorDataForDownloadReducer.vendorDataForDownload.data
    ? vendorDataForDownloadReducer.vendorDataForDownload.data
    : [];

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
  };

  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];
    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.vendorName,
        value: vendorsListForPlanner.vendorCode,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [vendorsListForPlannerReducer]);

  const [confirmationMsg, setConfirmationMsg] = useState(false);

  const onClickForConfirmation = () => {
    setConfirmationMsg(true);
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    setUploadLoader(true);

    let data = new FormData();

    data.append("file", uploadCsvData);

    let res = await uploadCsvForVendorUpload(data, jwtToken);

    if (res.status) {
      setUploadLoader(false);

      getVendorUpload(
        userId,
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      setUploadLoader(false);
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    {
      label: "vendorCode",
      key: "vendorCode",
    },
    { label: "stock", key: "stock" },
  ];

  const headers2 = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "vendorName",
      key: "vendorName",
    },
    { label: "stock", key: "stock" },
  ];

  const csvLink = {
    filename: "Vendor stock list.csv",
    headers: headers2,
    data: rows,
  };

  const csvLink2 = {
    filename: "Vendor stock template.csv",
    headers: headers,
    data: [],
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getVendorUpload(
        userId,
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={1} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-3}
              >
                <MDBox>
                  <MDBox display="flex" mt={2}>
                    {roleName !== "vendor" && (
                      <MDBox
                        width={{ xs: "250px", lg: "400px" }}
                        style={{
                          marginRight: "10px",
                        }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Vendors
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Vendors"
                          className="select-css-for-filter"
                          value={vendorsListForPlannerSelected}
                          options={vendorsListForPlannerOptions}
                          onChange={handleChangeVendorsListForPlanner}
                          autoComplete="off"
                        />
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>

                <MDBox
                  color="text"
                  px={2}
                  mt={4}
                  display="flex"
                  flexDirection={{ xs: "column", lg: "row" }}
                >
                  <MDBox mr={2}>
                    {uploadCsvFilter && (
                      <div>
                        <div>
                          <input
                            className="choose_file"
                            style={
                              {
                                // marginTop: "1.5rem",
                                // marginLeft: "0rem",
                                // marginBottom: "-9rem",
                              }
                            }
                            type="file"
                            accept=".csv"
                            onChange={(e) => {
                              setUploadCsvData(e.target.files[0]);
                            }}
                          />
                          <MDButton
                            disabled={
                              !uploadCsvData?.name ||
                              uploadCsvData?.type !== "text/csv"
                            }
                            variant="contained"
                            color="info"
                            style={{
                              marginLeft: "0",
                              marginTop: "0.3rem",
                              padding: 1,
                              height: "10px",
                            }}
                            type="button"
                            onClick={uploadCsvHandler}
                          >
                            Upload
                          </MDButton>
                        </div>
                        <div>
                          <span
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginLeft: "0px",
                              fontStyle: "italic",
                            }}
                          >
                            <strong>*</strong> Please upload
                            <strong>".csv"</strong> file only
                          </span>
                        </div>
                      </div>
                    )}
                  </MDBox>
                  <MDBox
                    display="flex"
                    marginRight={"50px"}
                    marginTop={!uploadCsvFilter ? "-8px" : "5px"}
                  >
                    {uploadAccess && (
                      <CSVLink {...csvLink2}>
                        <Tooltip>
                          <DownloadButton
                            tooltip="Download vendor stock template"
                            style={{ marginRight: "0.5rem" }}
                            type="button"
                            variant="outlined"
                            color="error"
                            iconOnly
                            title="Download vendor stock template"
                          >
                            <Icon>download</Icon>
                          </DownloadButton>
                        </Tooltip>
                      </CSVLink>
                    )}

                    {uploadAccess && (
                      <Tooltip>
                        <UploadButton
                          tooltip="Upload CSV"
                          type="button"
                          style={{ marginTop: "0.25rem" }}
                          variant="outlined"
                          color="info"
                          iconOnly
                          onClick={uploadCsvFilterHandler}
                          title="Upload CSV"
                        >
                          <Icon>upload</Icon>
                        </UploadButton>
                      </Tooltip>
                    )}

                    {downloadAccess && (
                      <CSVLink {...csvLink}>
                        <Tooltip>
                          <DownloadDataButton
                            tooltip="Download vendor stock list"
                            style={{ marginLeft: "0.5rem" }}
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            title="Download vendor stock list"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </Tooltip>
                      </CSVLink>
                    )}
                  </MDBox>
                </MDBox>
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={1}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  /* Table options */
                  options={{ draggable: false }}
                  /* Column reorder */
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  /* Meta */
                  subModuleId={subModuleId}
                  userId={userId}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {(uploadLoader || loading) && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    vendorUploadReducer: state.vendorUploadReducer,
    vendorDataForDownloadReducer: state.vendorDataForDownloadReducer,
    vendorsListForPlannerReducer: state.vendorsListForPlannerReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getVendorUpload: (
      userId,
      vendorCode,
      roleName,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getVendorUpload(
          userId,
          vendorCode,
          roleName,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),

    getVendorDataForDownload: (userId, jwtToken) =>
      dispatch(getVendorDataForDownload(userId, jwtToken)),
    getVendorsListForPlanner: (jwtToken) =>
      dispatch(getVendorsListForPlanner(jwtToken)),

    uploadCsvForVendorUpload: (payload, jwtToken) =>
      dispatch(uploadCsvForVendorUpload(payload, jwtToken)),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(VendorUpload);
